import { render, staticRenderFns } from "./RedaBtn.vue?vue&type=template&id=fafa817e&scoped=true"
import script from "./RedaBtn.vue?vue&type=script&lang=js"
export * from "./RedaBtn.vue?vue&type=script&lang=js"
import style0 from "./RedaBtn.vue?vue&type=style&index=0&id=fafa817e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafa817e",
  null
  
)

export default component.exports